import { Injectable } from "@angular/core";
import { GeoLocationApiService, ListGeoPostalCodesByCityPath, ListGeoStatesByCountryCdPath } from "@xpo-ltl-2.0/sdk-geolocation";
import { GetDistanceBetweenLocationsPath, InfrastructureApiService } from "@xpo-ltl-2.0/sdk-infrastructure";
import { map, Observable, of, tap } from "rxjs";
import { State } from "../model/state.model";
import { CountryCd } from "@xpo-ltl/sdk-common";

@Injectable({
  providedIn: 'root',
})
export class MileCalculatorService {
  states: State[];

  constructor(
    private infrastructureApiService: InfrastructureApiService,
    private geoLocationApiService: GeoLocationApiService
  ) {
    this.states = [];
  }

  getDistanceBetweenLocations(path: GetDistanceBetweenLocationsPath, queryParams = null): Observable<number> {
    return this.infrastructureApiService
      .getDistanceBetweenLocations(path, queryParams)
      .pipe(map((resp) => resp.distance));
  }

  listGeoPostalCodesByCity(path: ListGeoPostalCodesByCityPath): Observable<string[]> {
    return this.geoLocationApiService
      .listGeoPostalCodesByCity(path)
      .pipe(map((resp) => resp.postalCities?.map((loc) => loc.postalCd)));
  }

  listGeoStatesByCountryCd(countryCd: CountryCd): Observable<any> {
    const result = this.states.find(state => state.countryCd === countryCd);
    if (result && result.states.length) {
      return of(result.states);
    } else {
      return this.geoLocationApiService.listGeoStatesByCountryCd({ countryCd }).pipe(
        map((list) => {
          const states = list.geoStates || [];
          if (states.length) {
            return states.map((state) => state.countrySubdivisionCd);
          }
          return states;
        }),
        tap((states) => {
          this.states.push(new State(countryCd, states));
        })
      );
    }
  }
}
